<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->
  function closeAnnouncementBar() {
    const bar = document.getElementByClassName("div#custom_topbar");
    bar.style.display = "none";

    // Shift top positions
    document.getElementById("section#shopify-section-sections--18317145931968__custom_liquid_3qaCqX").style.top = "0px";
    document.getElementById("div#shopify-section-sections--18317145931968__9c03747e-b054-4db8-8194-5a35c71f82ca").style.top = "40px"; // only headerTopBar height
  }